import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeUp } from '../utils/motion';
type CapabilityNoetivraNoteProps = {
  capability: string;
};
export function CapabilityNoetivraNote({
  capability
}: CapabilityNoetivraNoteProps) {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white border-t border-line" data-id="element-112" data-mp="2jcy8fgz9rce0">
      <motion.div {...fadeUp} className="max-w-4xl mx-auto" data-id="element-113" data-mp="2jf0yu24c37j9">
        <p className="text-sm font-medium text-teal mb-3" data-id="element-114" data-mp="1vnvkxshyepbl">In practice</p>
        <p className="text-lg text-ink-dark leading-relaxed mb-4" data-id="element-115" data-mp="1rma9mbl2ij3i">
          Planned Noetivra modules could present tasks, feedback, and
          development activities related to {capability.toLowerCase()}, drawing
          on the approved definitions and research SyNeural maintains in its
          Semantic Knowledge Platform.
        </p>
        <p className="text-ink-muted leading-relaxed mb-6" data-id="element-116" data-mp="3gylx1fphgqez">
          The strong and weak patterns described on this page are educational
          examples, not established scoring categories. Any assessment of this
          capability would require validation for its intended use.
        </p>
        <div className="flex flex-wrap gap-x-8 gap-y-2" data-id="element-117" data-mp="3q2xki9dhchlx">
          <a href="/noetivra#human-capability-edition" className="inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-118" data-mp="3v3lk3jfry6rr">
            Noetivra Human Capability Edition
            <ArrowRight size={16} aria-hidden="true" data-id="element-119" data-mp="37e0ystw5exfb" />
          </a>
          <a href="/human-capability" className="inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-120" data-mp="37c6dhegyt3ap">
            Human Capability Platform
            <ArrowRight size={16} aria-hidden="true" data-id="element-121" data-mp="2jphpcb1d4eln" />
          </a>
        </div>
      </motion.div>
    </section>;
}